import React, { Component, createRef, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { fromJS } from "immutable";
import { currencyFormatter } from "utils/currencyHelper";

import { ReactComponent as GameIconFilled } from "assets/icons/Game-filled.svg";
import { ReactComponent as GameIconOutlined } from "assets/icons/Game-outlined.svg";
import { ReactComponent as WalletIconFilled } from "assets/icons/Wallet-filled.svg";
import { ReactComponent as WalletIconOutlined } from "assets/icons/Wallet-outlined.svg";

import { CommonTabs, CommonModalHeader } from "component/common";
import GamesRoundHistory from "containers/GamesRoundHistory";
import WalletTransactions from "containers/WalletTransactions";

import * as queryString from "query-string";

import "containers/History/styles.scss";
import { withNamespaces } from "react-i18next";
import ScrollDirectionTracker from "utils/ScrollDirectionTracker";

class History extends Component {
  constructor(props) {
    super(props);
    this.componentRef = createRef();
    this.titleRef = createRef();
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.setActiveTabIndex = this._setActiveTabIndex.bind(this);
    this.setLabel = this._setLabel.bind(this);
    this.setHistoryMonth = this._setHistoryMonth.bind(this);
    this.state = {
      showTitle: false,
      isTabsHidden: false,
    };

    this.scrollTracker = new ScrollDirectionTracker({
      scrollContainerSelector: ".history",
      threshold: 8,
      topOffset: 20,
      onChange: (isHidden) => this.setState({ isTabsHidden: isHidden }),
    });
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.titleRef.current) {
                this.setState({
                  showTitle: false,
                });
              }
            } else {
              if (this.titleRef.current) {
                this.setState({
                  showTitle: true,
                });
              }
            }
          });
        },
        {
          rootMargin: "50px 50px 50px 50px",
          threshold: 0.1,
        },
      );
      observer.observe(this.titleRef.current);
    } else {
    }
  }

  _setHistoryMonth(month, monthId) {
    const params = queryString.parse(this.props.location.search);

    if (month) {
      params.historyMonth = month;
      params.historyMonthId = monthId;
    } else {
      delete params.historyMonth;
      delete params.historyMonthId;
    }

    this.props.history.replace(
      `${this.props.location.pathname}?${queryString.stringify(params)}`,
    );
  }

  componentDidMount() {
    if (
      this.props.modalRel === "games-round-history.links" ||
      this.props.modalRel === "wallet-transactions" ||
      this.props.modalRel === "games-round-history"
    ) {
      this.initObserver();
      this.scrollTracker.start();
    }
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    if (
      prevProps.historyLinks !== this.props.historyLinks &&
      this.props.historyLinks &&
      !this.props.tabLinks
    ) {
      this.props
        .fetchGameRoundHistoryLinks(this.props.historyLinks)
        .then((response) => {
          return this.props.setGameRoundHistoryLinks(response);
        });
    }

    const wasOpen =
      prevProps.modalRel === "games-round-history.links" ||
      prevProps.modalRel === "wallet-transactions" ||
      prevProps.modalRel === "games-round-history";
    const isOpen =
      this.props.modalRel === "games-round-history.links" ||
      this.props.modalRel === "wallet-transactions" ||
      this.props.modalRel === "games-round-history";

    if (!wasOpen && isOpen) {
      this.initObserver();
      this.scrollTracker.start();
    } else if (wasOpen && !isOpen) {
      this.scrollTracker.stop();
    }
  }

  componentWillUnmount() {
    this.scrollTracker.stop();
  }

  _onClickPrevious() {
    this.props.history.goBack();
  }

  _onCloseClickHandler() {
    this.props.navigateTo(this.props.location.pathname);
  }

  _setActiveTabIndex(index) {
    let link = this.props.tabLinks.get(index);
    let params = queryString.parse(this.props.location.search);

    if (link) {
      params.link = JSON.stringify(link.toJSON());
      params.modalRel = link.get("rel");
    }

    params.activeTabIndex = index;
    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params,
    )}`;

    this.props.navigateTo(newLoc);
    this.componentRef.current.scrollTo({
      top: 0,
      behavior: `smooth`,
      duration: 500,
    });
  }

  _setLabel(item) {
    const { t } = this.props;
    switch (item.get("rel")) {
      case "games-round-history":
        return (
          <Fragment>
            <GameIconOutlined className="not-selected" />
            <GameIconFilled className="selected" />
            {t("game")}
          </Fragment>
        );
      case "wallet-transactions":
        return (
          <Fragment>
            <WalletIconOutlined className="not-selected" />
            <WalletIconFilled className="selected" />
            {t("wallet")}
          </Fragment>
        );
      default:
        return item.get("name");
    }
  }

  render() {
    const { t } = this.props;
    const { isTabsHidden } = this.state;

    if (
      this.props.modalRel !== "games-round-history.links" &&
      this.props.modalRel !== "wallet-transactions" &&
      this.props.modalRel !== "games-round-history"
    ) {
      return null;
    }

    return (
      <div
        data-testid="history"
        className={`history ${isTabsHidden ? "tabs-hidden" : ""}`}
        ref={this.componentRef}
      >
        <CommonModalHeader
          title={t("history")}
          showTitle={this.state.showTitle}
          onClickPrevious={this.onClickPrevious}
          onCloseClickHandler={this.onCloseClickHandler}
          backButtonTestId="back-button"
          closeButtonTestId="close-button"
        />
        <div className="title row" ref={this.titleRef}>
          {!this.props.tabLinks && (
            <div className="col nopadding">
              <span className="dummy">loading</span>
            </div>
          )}
          <div
            data-testid="page-title"
            className={`${this.props.tabLinks ? "col" : "d-none"} nopadding`}
          >
            {this.props.tabLinks ? t("history") : ""}
          </div>

          {this.props.balance && (
            <div className="col nopadding text-right">
              <span className="balance" data-testid="balance-amount">
                {currencyFormatter(this.props.balance, {
                  currency: this.props.currency,
                })}
              </span>
            </div>
          )}
        </div>
        <CommonTabs
          items={this.props.tabLinks}
          activeTabIndex={this.props.activeTabIndex}
          setActiveTabIndex={this.setActiveTabIndex}
          setLabel={this.setLabel}
          minimize={this.state.showTitle}
          getTabTestId={(item) => {
            switch (item.get("rel")) {
              case "games-round-history":
                return "game-tab";
              case "wallet-transactions":
                return "wallet-tab";
              default:
                return undefined;
            }
          }}
        />
        {(this.props.modalRel === "games-round-history.links" ||
          this.props.modalRel === "games-round-history") && (
          <GamesRoundHistory
            {...this.props}
            historyMonth={this.props.historyMonth}
            historyMonthId={this.props.historyMonthId}
            setHistoryMonth={this.setHistoryMonth}
          />
        )}
        {this.props.modalRel === "wallet-transactions" && (
          <WalletTransactions
            {...this.props}
            historyMonth={this.props.historyMonth}
            historyMonthId={this.props.historyMonthId}
            setHistoryMonth={this.setHistoryMonth}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let {
    modalRel,
    link,
    activeTabIndex,
    historyMonth,
    historyMonthId,
  } = queryString.parse(ownProps.location.search);
  let historyLinks;
  let gamesRoundHistoryLinks;
  let tabLinks;
  let currency;

  try {
    let profileLinks = state.profile.get("links");
    historyLinks = profileLinks.find((link) => {
      return link.get("rel") === "history.links";
    });
  } catch (err) {}

  try {
    gamesRoundHistoryLinks = state.historyLinks.find((link) => {
      return link.get("rel") === "games-round-history";
    });
  } catch (err) {}

  try {
    tabLinks = state.historyLinks.filter((link) => {
      return link.get("rel").indexOf("history.balance") === -1;
    });
  } catch (err) {}

  try {
    currency = state.links.get("currency");
  } catch (err) {}

  return {
    modalRel,
    link: link ? fromJS(JSON.parse(link)) : undefined,
    activeTabIndex: activeTabIndex ? activeTabIndex : 0,
    tabLinks: tabLinks.size > 0 ? tabLinks : null,
    displayName: state.user.get("displayName"),
    pages: state.urls.get("pages"),
    historyLinks,
    gamesRoundHistoryLinks,
    balance: state.profile.get("balance"),
    currency,
    historyMonth: historyMonth || null,
    historyMonthId: historyMonthId || null,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
    fetchGameRoundHistoryLinks: (route) =>
      dispatchProps.fetchGameRoundHistoryLinks(route),
    setGameRoundHistoryLinks: (payload) =>
      dispatchProps.setGameRoundHistoryLinks(payload),
    navigateTo: (path) => ownProps.history.push(path),
    goBack: (url) => dispatchProps.goBack(url),
    fetchHistoryBalance: (route) => dispatchProps.fetchHistoryBalance(route),
    setHistoryBalance: (reponse) => dispatchProps.setHistoryBalance(reponse),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withNamespaces("translation")(History));
